import InlineBanner from "../../../components/banner/InlineBanner";
import { useTranslation } from "../../../state/i18n";
import { resolveFallbackLanguage } from "../../../utils/languageUtil";
import { useCustomerState } from "../../../state/customer";
import BillingService from "../../../services/BillingService";
import PermissionService from "../../../services/PermissionService";
import { LEGACY_PLATFORM_BASE_URL, TRIAL_SUBMISSION_LIMIT } from "../../../constants";
import { createMemo } from "solid-js";
import { clamp, isNil } from "lodash-es";
import { daysUntil } from "../../../utils/dateUtil";
import { hours, seconds } from "../../../utils/timeUtil";

const TrialBanner = () => {
  const { t, currentLanguage } = useTranslation();
  const customer = useCustomerState();

  const usagePlanQuery = BillingService.getBillingUsage();
  const canManageBilling = createMemo(() => PermissionService.canManageBilling(customer.customerId));

  const trialDays = createMemo(() => {
    const cycle = usagePlanQuery.data?.plans.find((plan) => plan.type === "BASE")?.cycle;
    if (isNil(cycle)) {
      return { elapsed: 0, total: 0 };
    }

    const total = Math.round(seconds(cycle.end - cycle.start) / hours(24));
    const remaining = clamp(daysUntil(new Date(seconds(cycle.end))), 0, total);
    return { elapsed: total - remaining, total };
  });

  const submissionAmount = createMemo(() =>
    clamp(
      usagePlanQuery.data?.plans.find((plan) => plan.type === "FORMS")?.currentAmount ?? 0,
      0,
      TRIAL_SUBMISSION_LIMIT,
    ),
  );

  const openBilling = () =>
    window.location.assign(`${LEGACY_PLATFORM_BASE_URL}/customers/${customer.customerId}/billing/overview`);
  const openMeeting = () =>
    window.open(
      `https://links.moreapp.com/meeting/sales/${resolveFallbackLanguage(currentLanguage())}`,
      "_blank",
      "noopener",
    );

  return (
    <InlineBanner
      status="upgrade"
      title={t(($) => $.TRIAL_BANNER_TITLE)}
      accordionCollapseLabel={t(($) => $.TRIAL_BANNER_COLLAPSE_TITLE)}
      accordionExpandLabel={t(($) => $.TRIAL_BANNER_EXPAND_TITLE)}
      progressBars={[
        {
          label: t(($) => $.TRIAL_BANNER_PROGRESS_DAYS),
          max: trialDays().total,
          value: trialDays().elapsed,
        },
        {
          label: t(($) => $.TRIAL_BANNER_PROGRESS_SUBMISSIONS),
          max: TRIAL_SUBMISSION_LIMIT,
          value: submissionAmount(),
        },
      ]}
      primaryAction={
        canManageBilling() ? { label: t(($) => $.TRIAL_BANNER_PRIMARY_BUTTON), onClick: openBilling } : undefined
      }
      secondaryAction={
        canManageBilling() ? { label: t(($) => $.TRIAL_BANNER_SECONDARY_BUTTON), onClick: openMeeting } : undefined
      }
    />
  );
};

export default TrialBanner;
